import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=2d8d8c77&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=js&"
export * from "./CommonCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=2d8d8c77&prod&lang=scss&scoped=true&"
import style1 from "./CommonCard.vue?vue&type=style&index=1&id=2d8d8c77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d8c77",
  null
  
)

export default component.exports